// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sEn9","list":"styles_list__1Uck1","disableSelection":"styles_disableSelection__iTc4q"};